// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n3_q","col":"styles_col__1UnIb"};